import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AppLayoutComponent } from './component/app-layout/app-layout.component';
import { AppTopbarComponent } from './component/app-topbar/app-topbar.component';
import { AppSidebarComponent } from './component/app-sidebar/app-sidebar.component';
import { AppFooterComponent } from './component/app-footer/app-footer.component';
import { AppConfiguratorComponent } from './component/app-configurator/app-configurator.component';
import { AppFloatingConfiguratorComponent } from './component/app-floatingconfigurator/app-floatingconfigurator.component';
import { AppMenuComponent } from './component/app-menu/app-menu.component';
import { AppMenuitemComponent } from './component/app-menuitem/app-menuitem.component';
import { SharedModule } from '@app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';
import { MenuModule } from 'primeng/menu';

import { StyleClassModule } from 'primeng/styleclass';
import { PopoverModule } from 'primeng/popover';

import { UsuarioFormComponent } from '../shared/components/usuario-form/usuario-form.component';
import { NotificationsPanelComponent } from './component/notifications/notifications-panel.component';

import { AppMobileSidebarComponent } from './component/app-mobile-sidebar/app-mobile-sidebar.component';

@NgModule({
    declarations: [
        AppLayoutComponent,
        AppTopbarComponent,
        AppSidebarComponent,
        AppFooterComponent,
        AppConfiguratorComponent,
        AppFloatingConfiguratorComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        NotificationsPanelComponent,
        AppMobileSidebarComponent
    ],
    imports: [CommonModule, FormsModule, RouterModule, ButtonModule, StyleClassModule, PopoverModule, SelectModule, RippleModule, SelectButtonModule, SharedModule, MenuModule],
    exports: [AppLayoutComponent, AppFloatingConfiguratorComponent, AppMobileSidebarComponent]
})
export class LayoutModule {}
